import { DisplayComponent } from "~/components/newsletter/newsletter-widget/enums";
export const config = {
  defaultDisplayComponent: DisplayComponent.SignUpNewsletter,
  hasResetAfterSuccess: true,
  hasSanitizeSubscribedNewsletter: false
};